<template>
  <div>
    <nav class="navbar navbar-meta">
      <div class="container-fluid">
        <div class="navbar-header">
          <button @click="menuMobile()" type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#menu" aria-expanded="false">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand" @click="mudaPagina('/denuncia')" style="cursor: pointer;">
            <img height="35px" src="../assets/img/logo-azul.png" alt="logo meta">
          </a>
        </div>

        <div v-bind:class="{ 'collapse': expandirMobile }" class="navbar-collapse navbar-right" id="menu">
          <ul class="nav navbar-nav">
            <!-- Itens que são exibidos independentemente se o usuário está logado ou não -->
            <template v-for="item in links">
              <li v-bind:class="{ 'active': cLinkAtivo(item.link) }" v-bind:key="item.title"><a  @click="mudaPagina(item.link)">{{ item.title }}</a></li>
            </template>
            <!-- Itens que só serão exibidos se o usuário estiver logado -->
            <template v-if="verificaLogado()">
              <li v-bind:class="{ 'active': cLinkAtivo('/denuncia/lista-denuncias') }"><a @click="mudaPagina('/denuncia/lista-denuncias')">Lista de Denúncias</a></li>
              <li v-bind:class="{ 'active': cLinkAtivo('/documentos/assinaturas') }"><a @click="mudaPagina('/documentos/assinaturas')">Listar Assinaturas</a></li>
              <li><a @click="logout()"><i class="fa fa-sign-out"></i> Logout</a></li>
            </template>
            <!-- Item que só exibido se o usuário não estiver logado -->
            <li v-else v-bind:class="{ 'active': cLinkAtivo('/login') }">
              <a @click="mudaPagina('/denuncia/login')"><i class="fa fa-sign-in"></i> Login</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<style lang="scss" scoped>
  .navbar {
    margin-bottom: 0;
    padding: 0px 10vh;
  }

  ul > li:hover {
    cursor: pointer;
  }

  .navbar-meta {
    background-color: white;
    border: none;
    border-radius: 0;

    .navbar-toggle {
      border: 1px solid white;

      .icon-bar {
        background-color: white;
      }
    }

    li.active {
      background-color: rgb(233, 233, 233);
      a {
        color: rgb(85, 85, 85);
      }
    }

    li {
      a:hover {
        background-color: rgb(241, 241, 241);
      }

      a {
        color: #a7a7a7;
        margin: 5px 0;
      }
    }
  }
</style>

<script>
export default {
  name: 'Menu',
  data() {
    return {
      links: [
        {title: 'Formalize aqui a sua denúncia', link: '/denuncia', active: false,},
        {title: 'Acompanhamento de Denúncia', link: '/denuncia/consulta-denuncia', active: false,},
      ],
      expandirMobile: true,
    }
  },

  methods: {
    cLinkAtivo(string) {
      if (this.$route.path != string) {
        return false;
      }
      return true;
    },

    menuMobile() {
      this.expandirMobile = !this.expandirMobile;
    },

    mudaPagina(link) {
      this.$router.push({path: link});
    },

    verificaLogado() {
      if (!this.$localStorage.get('user')) {
        return false;
      }
      return true;
    },

    logout() {
      this.$localStorage.set('user', '');

      this.$router.push({ name: 'Login' });
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Menu.vue